// Material Kit 2 PRO React components
import MKBox from "components/MKBox";

// Material Kit 2 PRO React examples
import DefaultNavbar from "custom/Navbars/DefaultNavbar";
import DefaultFooter from "custom/Footers/DefaultFooter";

// Pricing page sections
import CareerHeader from "pages/about-us/company/Career/sections/Header";
import CareerFaq from "pages/about-us/company/Career/sections/Faq";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function CareerPage() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "mailto:info@pwncat.com",
          label: "Únete a Nosotros",
        }}
        mobile={{
          color: "white",
        }}
        transparent
        light
      />
      <CareerHeader />
      <MKBox p={3}>
        <CareerFaq />
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default CareerPage;